import axios from "axios";

export default {
  async getGatiOrderSettings() {
    return axios.get(`/admin/system/GetGatiOrderServiceConfig`, {});
  },
  async updateGatiOrderSettings(data) {
    return axios.put(`/admin/system/UpdateGatiOrderServiceConfig`, data);
  },
  async getGRPSettings() {
    return axios.get(`/admin/system/GetAipGrpServiceConfig`);
  },
  async uploadAipProjectExecutions(){
    return axios.post(`/admin/integration/UploadAipProjectExecutions`, {});
  },
  async getPpurSettings() {
    return axios.get(`/admin/system/GetMkaServiceConfig`);
  },
  async updatePpurSettings(data) {
    return axios.put(`/admin/system/UpdateMkaServiceConfig`, data);
  },
  async getAsuEdsSettings() {
    return axios.get(`/admin/system/GetAsuEdsServiceConfig`);
  },
  async updateAsuEdsSettings(data) {
    return axios.put(`/admin/system/UpdateAsuEdsServiceConfig`, data);
  },
  async updateGrpSettings(data) {
    return axios.put(`/admin/system/UpdateAipGrpServiceConfig`, data);
  },
  async updateBpIekSettings(data) {
    return axios.put(`/admin/system/UpdateBpIekServiceConfig`, data);
  },
  async getSitPanelConfig() {
    return axios.get(`/admin/system/getSitPanelConfig`);
  },
  async updateSitPanelConfig(data) {
    return axios.put(`/admin/system/updateSitPanelConfig`, data);
  },
};
